import Screen from '../../components/screen';
import Container from '../../components/container';
import ScreenTitle from '../../components/screen-title';
import ContactButton from '../../components/contact-button';
import LogoSvg2 from '../../components/svg/logo-svg2';
import frenteIndustria from '../../assets/images/frente-industria.png';

export default function Company() {
	return (
		<Screen>
			<ScreenTitle title={'A Empresa'}/>

			<Container>
				<div className={'flex flex-col sm:flex-row sm:gap-20 gap-y-12 sm:gap-y-0 sm:px-16'}>
					<div className={'flex justify-center'}>
						<LogoSvg2 className={'w-56'}/>
					</div>
					<div className={'col-span-3 sm:col-span-2 text-justify'}>
						<div className={'roboto'}>
							A Fast Soluções Industriais é uma empresa localizada na cidade de Forquilhinha - SC com inicio das
							suas atividades no ano de 2023. Dedicada em oferecer soluções inovadoras e eficientes para o setor
							industrial,com uma sólida experiência no mercado, nossa missão é desenvolver soluções inovadoras na
							área mecânica, comprometendo-se em superar as expectativas de nossos clientes e colaboradores.
						</div>
						<div className={'roboto pt-4'}>
							Com uma equipe de profissionais qualificados e comprometidos com a excelência, a Fast Soluções Industriais
							se destaca pela rapidez na entrega, inovação constante e um atendimento de alta qualidade. 
						</div>
					</div>
				</div>

				<div className={'w-full sm:px-32 py-12'}>
					<img src={frenteIndustria} alt='Imagem frente indutria' />
				</div>

				<div className={'flex justify-center'}>
					<ContactButton color={'black'}/>
				</div>

				<section className={'pt-8 space-y-4'}>
					<div className={'text-center flex flex-col items-center'}>
						<p className={'sm:text-5xl text-3xl py-4'}>Missão</p>
						<p className={'roboto'}>
							Desenvolver soluções inovadoras na área mecânica, comprometendo-se em superar as expectativas de nossos clientes e colaboradores.
						</p>
						<div className={'border-2 sm:border-4 border-primary w-48 sm:w-96 my-4'}></div>
					</div>

					<div className={'text-center flex flex-col items-center'}>
						<p className={'text-3xl sm:text-5xl py-4'}>Visão</p>
						<p className={'roboto'}>
							Tornar-se referencia no segmento, se destacando pela qualidade, agilidade e competitividade dos trabalhos técnicos entregues.
						</p>
						<div className={'border-2 sm:border-4 border-primary w-48 sm:w-96 my-4'}></div>
					</div>

					<div className={'text-center flex flex-col items-center'}>
						<p className={'text-3xl sm:text-5xl py-4'}>Valores</p>
						<p className={'roboto'}>
							Ética, inovação, transparência, honestidade, responsabilidade e dedicação.
						</p>
					</div>
				</section>
			</Container>
		</Screen>
	);
}